/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cations stabilise the DNA duplex, raising the Tm, and a higher strand concentration shifts the equilibrium toward the duplex. Both appear in the nearest-neighbor equation, so entering your reaction's values gives a realistic Tm.`)
};

const es_tm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los cationes estabilizan el dúplex de ADN, elevando la Tm, y una mayor concentración de hebra desplaza el equilibrio hacia el dúplex. Ambos aparecen en la ecuación de vecino más cercano, así que introducir los valores de tu reacción da una Tm realista.`)
};

const de_tm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kationen stabilisieren den DNA-Duplex und erhöhen die Tm, und eine höhere Strangkonzentration verschiebt das Gleichgewicht in Richtung Duplex. Beide erscheinen in der Nearest-Neighbor-Gleichung, sodass die Eingabe Ihrer Reaktionswerte eine realistische Tm ergibt.`)
};

const nl_tm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kationen stabiliseren de DNA-duplex, waardoor de Tm stijgt, en een hogere strengconcentratie verschuift het evenwicht richting de duplex. Beide komen voor in de nearest-neighbor-vergelijking, dus het invullen van de waarden van jouw reactie geeft een realistische Tm.`)
};

const fr_tm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les cations stabilisent le duplex d'ADN, augmentant la Tm, et une concentration de brin plus élevée déplace l'équilibre vers le duplex. Les deux apparaissent dans l'équation des plus proches voisins, donc entrer les valeurs de votre réaction donne une Tm réaliste.`)
};

const it_tm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I cationi stabilizzano il duplex di DNA, aumentando la Tm, e una concentrazione più alta del filamento sposta l'equilibrio verso il duplex. Entrambi compaiono nell'equazione dei vicini più prossimi, quindi inserire i valori della tua reazione dà una Tm realistica.`)
};

const pt_br2_tm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cátions estabilizam a dupla-fita de DNA, elevando a Tm, e uma concentração mais alta da fita desloca o equilíbrio em direção à dupla-fita. Ambos aparecem na equação do vizinho mais próximo, então informar os valores da sua reação fornece uma Tm realista.`)
};

const pt_tm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os catiões estabilizam o duplex de ADN, aumentando a Tm, e uma concentração mais elevada da cadeia desloca o equilíbrio no sentido do duplex. Ambos aparecem na equação do vizinho mais próximo, pelo que introduzir os valores da sua reação dá uma Tm realista.`)
};

const ja_tm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`陽イオンはDNA二本鎖を安定化させTmを上げ、鎖濃度が高いほど平衡が二本鎖側に傾きます。どちらも最近接塩基対法の式に含まれているため、反応の値を入力すると現実的なTmが得られます。`)
};

const zh_tm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阳离子会稳定 DNA 双链，从而提高 Tm；较高的链浓度会使平衡向双链方向移动。两者都出现在最近邻方程中，因此输入你反应体系的实际数值可得到更真实的 Tm。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_faq_a2", locale)
	if (locale === "en") return en_tm_faq_a2(inputs)
	if (locale === "es") return es_tm_faq_a2(inputs)
	if (locale === "de") return de_tm_faq_a2(inputs)
	if (locale === "nl") return nl_tm_faq_a2(inputs)
	if (locale === "fr") return fr_tm_faq_a2(inputs)
	if (locale === "it") return it_tm_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_tm_faq_a2(inputs)
	if (locale === "pt") return pt_tm_faq_a2(inputs)
	if (locale === "ja") return ja_tm_faq_a2(inputs)
	return zh_tm_faq_a2(inputs)
};